module.exports = __webpack_public_path__ + "static/media/SquareDefaultImg.1eb0de10.png";